import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`bliss-logo ${className}`} data-testid="header-logo-link" aria-label="Blissbranding Agency home">
    <span className="bliss-logo-name">Blissbranding</span>{" "}
    <span className="bliss-logo-agency">Agency</span>
    <span className="bliss-logo-dot">.</span>
  </Link>
);
